const json = {
    "data": [
		{
			"id": "0",
			"question_img": "01-bg",
			"question_layers": ["01"],
			"question": "Na Albertově se prý chystá studentská demonstrace k&nbsp;výročí 17. listopadu.",
			"answer_a": "Zůstaneš doma koukat na pořad Křeslo pro hosta.",
			"answer_b": "Půjdeš s&nbsp;ostatními na Albertov.",
			"modal_a_img": "modal_img_rage",
			"modal_a": "<h3><b>Telefonuje Ti kamarád a&nbsp;říká: &#8222;Čekám dole, dělej, tohle bude velký!&#8220; Tak se rozhodneš přidat. Televize počká.</b></h3>",
			"modal_b_img": "modal_img_ok",
			"modal_b": "<h3><b>A na Albertově už čeká dav studentů.<b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "01"
		},
		{
			"id": "1",
			"question_img": "02-bg",
			"question_layers": ["02-01","02-02","02-04","02-05","02-06","02-07","02-08"],
			"question": "Dav studentů došel podle plánu na Vyšehrad, ale zdá se, že část hodlá pokračovat.",
			"answer_a": "Jdeš dál s&nbsp;davem.",
			"answer_b": "Otočíš se a&nbsp;jdeš domů.",
			"modal_a_img": "modal_img_ok",
			"modal_a": "<h3><b>Správně děláš!<b></h3>",
			"modal_b_img": "modal_img_rage",
			"modal_b": "<h3><b>Kamarád Tě vezme za rameno: &#8222;Teď chceš jít? Snad se nebojíš?!&#8220; Má pravdu, zůstaneš.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "02-07-12"
		},
		{
			"id": "2",
			"question_img": "03-bg",
			"question_layers": ["03-01","03-02","03-03"],
			"question": "Průvod dorazí na křižovatku Vyšehradská a&nbsp;Na Slupi. Tady dojde k&nbsp;prvnímu násilnému zásahu proti demonstrantům.",
			"answer_a": "Utíkáš domů. Přece se nenecháš zmlátit!",
			"answer_b": "Bojíš se, ale zůstaneš.",
			"modal_a_img": "modal_img_rage",
			"modal_a": "<h3><b>Kamarád na Tebe volá: &#8222;Neblbni, dneska se může změnit všechno!&#8220;. Máš strach, ale souhlasíš. Nejde přece pořád jen ustupovat.</b></h3>",
			"modal_b_img": "modal_img_stb",
			"modal_b": "<h3><b>Je v Tobě malá dušička, ale zůstáváš dál. Přece v tom kámoše nenecháš!</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "03",
			"satype" : "shift"
		},
		{
			"id": "3",
			"question_img": "04-bg",
			"question_layers": ["04-1","04-2","04-3","04-4"],
			"question": "Na Rašínově nábřeží si všimneš kordonu policejních antonů. Z toho pohledu až&nbsp;mrazí.",
			"answer_a": "Atmosféra houstne. Poprvé Tě napadne, že se OPRAVDU může všechno změnit.",
			"answer_b": "Doma Ti říkali, ať se do ničeho nepleteš. Zaženeš tu myšlenku a jdeš dál.",
			"modal_a_img": "modal_img_what",
			"modal_a": "<h3><b>Antony skutečně čekaly, až se dav shromáždí na Národní třídě, aby následně po zuby ozbrojení esenbáci zasáhli i&nbsp;z&nbsp;druhé strany průvodu.</b></h3>",
			"modal_b_img": "modal_img_what",
			"modal_b": "<h3><b>Antony skutečně čekaly, až se dav shromáždí na Národní třídě, aby následně po zuby ozbrojení esenbáci zasáhli i&nbsp;z&nbsp;druhé strany průvodu.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "04",
			"satype" : "change"
		},
		{
			"id": "4",
			"question_img": "05-bg-all",
			"question": "Jdeš kolem Národního divadla.",
			"answer_a": "Spolu s davem skanduješ na zdiskreditované umělce: Herci ven! Herci ven!",
			"answer_b": "Z okna a&nbsp;balkónu divadla mávají herci, kteří ten večer hrají představení Dantova smrt. Mezi nimi i&nbsp;Josef Kemr. Z balkónu se ozývá volání Svobodu! Svobodu! Dav odpovídá skandováním: Ať žijí herci. Ať žije Kemr!",
			"modal_a_img": "modal_img_mask_rage",
			"modal_a": "<h3><b>Tak to nebylo. Herci studentský průvod naopak podporují. K&nbsp;provolávání hesel se připojili.</b></h3>",
			"modal_b_img": "modal_img_mask",
			"modal_b": "<h3><b>Máváte si vzájemně. Průvod pokračuje dál po Národní.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "05",
			"satype" : "none"
		},
		{
			"id": "5",
			"question_img": "06-bg",
			"question_layers": ["06-01","06-02","06-03","06-04","06-05"],
			"question": "Když se blížíte k&nbsp;policejnímu kordonu, všichni hromadně zpíváte",
			"answer_a": "Modlitba pro Martu.",
			"answer_b": "Ach synku, synku, Jednou budem dál a&nbsp;hymnu.",
			"modal_a_img": "modal_img_recorder",
			"modal_a": "<h3><b>Dnes ještě ne, došlo na ni až v dalších revolučních dnech. 17. listopadu zpívali demonstranti lidovou Ach synku, synku, oblíbenou píseň prvního československého prezidenta Tomáše Garrigue Masaryka.</b></h3>",
			"modal_b_img": "modal_img_recorder",
			"modal_b": "<h3><b>Ano, pátek 17. listopadu zní symbolicky oblíbená píseň prvního československého prezidenta Tomáše Garrigue Masaryka.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "06"
		},
		{
			"id": "6",
			"question_img": "07-bg",
			"question_layers": ["07-01","07-02","07-03","07-04","07-05","07-06"],
			"question": "Dav skanduje:",
			"answer_a": "Prokeše do koše!",
			"answer_b": "Jakeše do koše!",
			"modal_a_img": "modal_img_jakes",
			"modal_a": "<h3><b>Jen ses přeslechl a&nbsp;voláš dál s ostatními: Jakeše do koše! Tajemník KSČ je hlavní představitel totalitního režimu, proti kterému demonstrujete.</b></h3>",
			"modal_b_img": "modal_img_jakes",
			"modal_b": "<h3><b>Správně. Milouš Jakeš, generální tajemník KSČ, tvář režimu v roce 1989, musí skončit stejně jako totalita.</b></h3>",
			"mp3": "02-07-12",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"satype" : "waving"
		},
		{
			"id": "7",
			"question_img": "08-bg-all",
			"question": "Tvoji rodiče.",
			"answer_a": "Když přijedeš na víkend domů s&nbsp;trikolórou na kabátě, jsou trochu v šoku. Nic nevědí, ve zprávách nic nebylo.",
			"answer_b": "Jsou vyděšení. Fotky a&nbsp;videa z&nbsp;brutálního zásahu se rychle šíří celou zemí a&nbsp;vyvolávají bouři nevole.",
			"modal_a_img": "modal_img_news",
			"modal_a": "<h3><b>Ještě ve zprávách ze soboty 18. listopadu nebyla o zásahu na Národní ani zmínka. Režim se snažil událost ututlat. Regiony se o dění na Národní třídě dozvídají s dvoudenním zpožděním.</b></h3>",
			"modal_b_img": "modal_img_news",
			"modal_b": "<h3><b>Kdyby to tak bylo, možná by režim padl mnohem dřív. Cenzura ale dokázala zprávy o dění v Praze držet tvrdě na uzdě.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "08",
			"satype" : "none"
		},
		{
			"id": "8",
			"question_img": "09-bg-all",
			"question": "Kamarád tvrdí, že kousek od Jungmannovy ulice viděl ležet tělo přikryté zakrvácenou vlajkou. Prý je to Martin Šmíd, student zabitý během zásahu.",
			"answer_a": "To je strašné! Šíříš tu zprávu dál. Tohle určitě musí být pravda.",
			"answer_b": "Je to fáma. Naštěstí, řekneš si a&nbsp;neděláš si s&nbsp;tím hlavu.",
			"modal_a_img": "modal_img_what",
			"modal_a": "<h3><b>Falešnou zprávu o smrti Martina Šmída, která přispěla k&nbsp;aktivaci národa, dodnes zahaluje směs tajemství a&nbsp;konspiračních teorií. Zprávu nejspíš pustila do světa Drahomíra Dražská, vrátná na vysokoškolských kolejích v Praze–Troji. Podle ní &#8222;ze vzteku a&nbsp;bezmoci&#8220;, když v nemocnici čekala na ošetření, protože byla při zákroku na Národní lehce zraněná.</b></h3>",
			"modal_b_img": "modal_img_what",
			"modal_b": "<h3><b>Falešnou zprávu o smrti Martina Šmída, která přispěla k&nbsp;aktivaci národa, dodnes zahaluje směs tajemství a&nbsp;konspiračních teorií. Zprávu nejspíš pustila do světa Drahomíra Dražská, vrátná na vysokoškolských kolejích v Praze–Troji. Podle ní &#8222;ze vzteku a&nbsp;bezmoci&#8220;, když v nemocnici čekala na ošetření, protože byla při zákroku na Národní lehce zraněná.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "09-01",
			"satype" : "none"
		},
		{
			"id": "9",
			"question_img": "10-bg-all1",
			"question": "Koukneš se pod nohy. Kromě běžného pouličního nepořádku zahlédneš dvě věci, které Tě zaujmou. Kterou si vybereš?",
			"answer_a": "Dlažební kostku",
			"answer_b": "Květinu",
			"modal_a_img": "modal_img_security",
			"modal_a": "<h3><b>Kamarád Tě zastaví, zakroutí hlavou a&nbsp;vloží Ti raději květinu do ruky. Není sice nejčerstvější, ale to neřešíš. Vidíš, jak i&nbsp;ostatní dávají esenbákům za štíty květy. Chcete změnu. Ale ne násilí a&nbsp;krev.</b></h3>",
			"modal_b_img": "modal_img_security",
			"modal_b": "<h3><b>Správně! Uděláš to co, ostatní. Jako ostatní vložíš květinu za štít esenbákovi jako projev mírového protestu.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "10-15",
			"satype" : "none"
		},
		{
			"id": "10",
			"question_img": "11-bg",
			"question_layers": ["11"],
			"question": "Někdo vykřikne, že na Prahu už jedou tanky. Režim se bude bránit.",
			"answer_a": "Nevěříš a&nbsp;zůstaneš v davu.",
			"answer_b": "Zabalíš to a&nbsp;jdeš radši domů.",
			"modal_a_img": "modal_img_ok",
			"modal_a": "<h3><b>Správně děláš. Další z&nbsp;demonstrujících odhalí, že&nbsp;zvěst o&nbsp;tancích je fáma záměrně šířená Státní bezpečností. Vláda vás chce znejistit.</b></h3>",
			"modal_b_img": "modal_img_rage",
			"modal_b": "<h3><b>Pomalu se tlačíš směrem k okraji davu. Zbývá už jen pár kroků, když Tě někdo chytne za rukáv a&nbsp;říká: “Pošli to dál! Ty tanky jsou lež. Chtějí nás zastrašit!“ A&nbsp;pak ještě – &#8222;Víš co to znamená? Oni se nás bojí!&#8220;.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "11",
			"satype" : "tank"
		},
		{
			"id": "11",
			"question_img": "12-bg",
			"question_layers": ["12-01","12-02","12-03","12-04","12-05","12-06","12-07","12-08"],
			"question": "Zaslechneš někoho říkat, že kousek od vás je prý i Havel. Víš o něm jen to, že je to dramatik, politický vězeň, disident. Co uděláš?",
			"answer_a": "Trochu se stydíš, ale&nbsp;neodoláš. Jdeš za ním, abys mu řekl, jak si ho vážíš.",
			"answer_b": "Neuděláš nic.",
			"modal_a_img": "modal_img_castle",
			"modal_a": "<h3><b>Protlačíš se k&nbsp;němu, poklepeš mu na rameno… A&nbsp;zjistíš, že to není Václav Havel. Později ses dozvěděl, že disidenti se průvodu neúčastnili, aby režimu nedávali záminku protest zakázat.</b></h3>",
			"modal_b_img": "modal_img_castle",
			"modal_b": "<h3><b>Stejně bys byl jen zklamaný, protože Václav Havel to určitě nebyl. Disidenti se průvodu neúčastnili, aby režimu nedávali záminku protest zakázat.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "02-07-12"
		},
		{
			"id": "12",
			"question_img": "13-bg",
			"question_layers": ["13"],
			"question": "Esenbáci začínají tlačit dav od nábřeží směrem k&nbsp;Národní třídě.",
			"answer_a": "Snažíš se prodrat co nejvíc dopředu.",
			"answer_b": "Snažíš se prodrat ven z&nbsp;davu, nebo aspoň dozadu.",
			"modal_a_img": "modal_img_stb",
			"modal_a": "<h3><b>Je to úplně jedno, není kam jít, atmosféra houstne.</b></h3>",
			"modal_b_img": "modal_img_stb",
			"modal_b": "<h3><b>Je to úplně jedno, není kam jít, atmosféra houstne.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "13"
		},
		{
			"id": "13",
			"question_img": "14-bg-all",
			"question": "Esenbáci tvoří uličku v čele průvodu a&nbsp;tlačí tam dav. Tohle je možná poslední šance odejít.",
			"answer_a": "Nikam nejdu. Přece v&nbsp;tom ostatní nenechám!",
			"answer_b": "Tohle není nic pro mě. Zkusím se tam dostat. Mám toho dost.",
			"modal_a_img": "modal_img_ok",
			"modal_a": "<h3><b>Studenti si sedají na zem v mírumilovném protestu. Přidáš se.</b></h3>",
			"modal_b_img": "modal_img_rage",
			"modal_b": "<h3><b>Těsně před Tebou se možnost demonstraci opustit uzavře. Nedá se nic dělat. Sedáš si na zem s ostatními.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "14",
			"satype" : "none"
		},
		{
			"id": "14",
			"question_img": "15-bg",
			"question_layers": ["15-01","15-02"],
			"question": "Máš s sebou zapalovač.",
			"answer_a": "Z kapsy vyndáš zápalnou lahev, škrtneš zapalovačem a&nbsp;lahev hodíš mezi příslušníky SNB.",
			"answer_b": "Pár lidí má u sebe svíčky. Zapálené je staví před kordon policajtů na dlažbu. Ostatní svítí aspoň zapalovači.",
			"modal_a_img": "modal_img_rage",
			"modal_a": "<h3><b>To bys tomu dal! Esenbáci jen číhají na to, aby mohli vyzkoušet všechny ty brutální metody, které znají doteď spíš jen z doslechu. Zkusí sice pár útoků, ale dav se vyprovokovat nenechá. Ani Ty ne. Zapálíš raději svíčku.</b></h3>",
			"modal_b_img": "modal_img_ok",
			"modal_b": "<h3><b>Rozsvěcejí se další a&nbsp;další zapalovače. Atmosféra se mění. Díky důrazu na nenásilný protest dostala tahle revoluce později jméno sametová.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "10-15"
		},
		{
			"id": "15",
			"question_img": "16-bg",
			"question_layers": ["16-01","16-02","16-03"],
			"question": "Esenbáci dostávají rozkaz a&nbsp;začíná masakr. Tlučou vás obušky hlava nehlava, holky, kluky, je to příšerné.",
			"answer_a": "Chráním si hlavně hlavu a&nbsp;záda.",
			"answer_b": "Snažím se vyhýbat ránám.",
			"modal_a_img": "modal_img_beating",
			"modal_a": "<h3><b>Je to jedno, taky jsi jednu schytal přes záda.</b></h3>",
			"modal_b_img": "modal_img_beating",
			"modal_b": "<h3><b>Je to jedno, taky jsi jednu schytal přes záda.</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center js-close-modal\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "16"
		},
		{
			"id": "16",
			"question_img": "17-bg-black",
			"question_layers": ["17"],
			"question": "Je po všem. Spoustu lidí odvezly policejní antony. Někteří jsou zranění. Jsi unavený, ale&nbsp;cítíš, že&nbsp;jste se zachovali správně. Na nočním nebi se jako zázrakem objevuje nevídaná polární záře.",
			"answer_a": "Máš hlavu plnou dojmů. Snad to k&nbsp;něčemu bylo.",
			"answer_b": "Už toho bylo vážně dost, ale dnešek není konec, ale začátek. To jsme si o&nbsp;svobodu skutečně řekli.",
			"modal_a_img": "modal_img_final",
			"modal_a": "<h3><b>Stálo to za to! Zmlácení a&nbsp;pozavíraní studenti odstartovali revoluci. Naši cestu k&nbsp;současné svobodě. Nezapomínejme, že&nbsp;svoboda není samozřejmost</b></h3>",
			"modal_b_img": "modal_img_final",
			"modal_b": "<h3><b>Stálo to za to! Zmlácení a&nbsp;pozavíraní studenti odstartovali revoluci. Naši cestu k&nbsp;současné svobodě. Nezapomínejme, že&nbsp;svoboda není samozřejmost</b></h3>",
			"modal_button": "<a href=\"#\" class=\"btn btn--big btn--red btn--radius-10 btn--shadow-red btn--hover flex align-items-sm--center\" data-request=\"end.ajax.html\"><strong class=\"btn__text btn__text--white font-size--18 text-transform--uppercase\">Pokračovat dál</strong><i class=\"icon icon--arrow icon--arrow-big\"></i></a>",
			"mp3": "17"
		}
	]
};
export default json;

